import { InputGroup } from "@blueprintjs/core"
import React, { useCallback } from "react"
import { useContextForm } from "../Organisms/ContextForm"
import CustomFormGroup from "../Atoms/CustomFormGroup"

const NumberInput = ({
  className,
  path,
  disabled = undefined,
  type = undefined,
  label,
  placeholder = undefined,
  ...otherProps
}) => {
  const {
    value,
    touched,
    error,
    disabled: contextDisabled,
    onFocus,
    onChange,
  } = useContextForm(path)

  const handleChange = e => {
    onChange(path, e.target.value)
  }
  const handleFocus = useCallback(() => {
    onFocus(path)
  }, [onFocus, path])

  return (
    <CustomFormGroup
      disabled={disabled ? disabled : contextDisabled}
      className={className}
      label={label}
      error={error && touched ? error : null}
      {...otherProps}
    >
      <InputGroup
        disabled={disabled ? disabled : contextDisabled}
        type={type}
        onFocus={handleFocus}
        value={value ? value : ""}
        onChange={handleChange}
        placeholder={placeholder}
        {...otherProps}
      />
    </CustomFormGroup>
  )
}
export default NumberInput
